import React from 'react'

import classNames from './LibraryPicker.css'
import { titleCase } from '../../utils/string'

export default function LibraryPicker ({ value, onCancel, addTerm, removeTerm, libraries }) {
  const renderLibrary = name => {
    const index = value.findIndex(library => library.value === name)
    const active = index !== -1
    const onRemove = () => removeTerm('library', index)
    const onAdd = () => addTerm('library', name, 'should')
    const isVirtual = /^virtual_/.test(name)
    return (
      <button
        key={name}
        className={active ? classNames.button : classNames.greyButton}
        onClick={active ? onRemove : onAdd}>
        {isVirtual ? 'Shared' : titleCase(name)}
      </button>
    )
  }
  const removeAll = () => {
    value.map(() => removeTerm('library', 0))
  }
  const selectAll = () => {
    libraries.map(name => addTerm('library', name, 'should'))
  }
  return (
    <div className={classNames.buttons}>
      {libraries.map(renderLibrary)}
      <br />
      <button className={classNames.tool} onClick={selectAll}>
        Select all
      </button>
      <button className={classNames.tool} onClick={removeAll}>
        Select none
      </button>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/search/LibraryPicker.js